import { Action, ThunkAction } from "@reduxjs/toolkit"
import { StoreState } from "../store/StoreState"
import { wishActions, wishSelectors } from "@/slices/wishSlice"
import { callAuthedApi } from "@/services/serverService"

export const ensureWishListsThunk =
  (force?: boolean): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    if (!force && wishSelectors.wishLists(getState())) {
      return
    }
    const data = await callAuthedApi<{ wishLists: IWishListDto[] }>("wishlists", "get")
    dispatch(wishActions.setWishLists(data.wishLists))
  }

export const updateWishThunk =
  (wish: IWishDto, wishListId: number): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    await callAuthedApi<{ wishLists: IWishListDto[] }>("updateWish", "post", {
      wish,
      wishListId,
    })
    await dispatch(ensureWishListsThunk(true))
  }

export const registerWishThunk =
  (wishId: number, change: number): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    await callAuthedApi("registerWish", "post", {
      wishId,
      change,
    })
    await dispatch(ensureWishListsThunk(true))
  }

export const changeWishSortingThunk =
  (
    wishId: number,
    afterWishId?: number,
    beforeWishId?: number
  ): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    await callAuthedApi<{ wishLists: IWishListDto[] }>("changeSorting", "post", {
      wishId,
      afterWishId,
      beforeWishId,
    })
    await dispatch(ensureWishListsThunk(true))
  }
